import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { nameof } from '../../utils/object';
import { OrderDefinition } from 'stores/dataStore';
import { RejectedByDto, RejectedByStore } from 'stores/configuration/events-n-requests/rejected-by-store';
import TailwindSelect from 'widgets/editors/tailwind-select';

interface TailwindRejectedByComponentProps extends WithTranslation {
  value: string;
  onChange: (value: any) => void;
  placeholder?: string;
  clearable?: boolean;
  rejectedByStore?: RejectedByStore;
  readOnly?: boolean;
  className?: string;
}

interface TailwindRejectedByComponentState {
  rejectedBy: { text: string; value: string }[];
  isLoading: boolean;
}

@connect(['rejectedByStore', RejectedByStore])
class TailwindRejectedByComponent extends Component<TailwindRejectedByComponentProps, TailwindRejectedByComponentState> {
  private get rejectedByStore() {
    return this.props.rejectedByStore;
  }

  state: TailwindRejectedByComponentState = { isLoading: false, rejectedBy: [] };

  componentDidMount() {
    this.loadRejectedByStore();
  }

  private loadRejectedByStore = async () => {
    try {
      this.setState({ isLoading: true });
      const filter = [];

      const orderBy: OrderDefinition[] = [{ direction: 'Ascending', field: nameof<RejectedByDto>('name'), useProfile: false }];

      return await this.rejectedByStore.getAllAsync({ searchQuery: '', skip: 0, take: 100000, orderBy, filter }).then(rejectedByStore => {
        const options = [];
        rejectedByStore.items.forEach(rejectReason => options.push({ text: rejectReason.name, value: rejectReason.id }));
        this.setState({ rejectedBy: options });
      });
    } catch (error) {
      console.error('Error loading locations:', error);
      this.setState({ rejectedBy: [] });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  private handleOnChange = (newValue: string | null) => {
    const selected = newValue ? this.state.rejectedBy.find(opt => opt.value === newValue) : null;
    const itemRef = selected ? { id: selected.value, title: selected.text } : null;
    this.props.onChange?.(itemRef);
  };

  public render() {
    const { rejectedBy, isLoading } = this.state;
    const { t, readOnly, value, placeholder } = this.props;
    return (
      <TailwindSelect
        options={
          isLoading
            ? [{ id: 'loading', text: t('Loading...'), disabled: true }]
            : rejectedBy.length > 0
            ? rejectedBy.map(by => ({
                id: by.value,
                text: by.text
              }))
            : [{ id: 'no-options', text: t('No options available'), disabled: true }]
        }
        value={value ?? ''}
        onChange={this.handleOnChange}
        placeholder={placeholder || t('Select Rejected By')}
        clearable
        searchable={!isLoading}
        className="w-full"
        disabled={readOnly}
      />
    );
  }
}

export default withTranslation()(TailwindRejectedByComponent);
